import type { PromptTemplate } from '@/components/chat/prompt-template.interface'
import type { DataTableAction } from '@/components/data-table/data-table.interface'

export const createPromptTemplateActionList = (
  onEdit: (template: PromptTemplate) => void,
  onDelete: (template: PromptTemplate) => void
): DataTableAction<PromptTemplate>[] => [
  {
    id: 'edit',
    label: 'Edit',
    onClick: onEdit,
  },
  {
    id: 'delete',
    label: 'Delete',
    variant: 'destructive',
    onClick: onDelete,
  },
]
